/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Toast_Start_OkInputs */

const vi_cdo_toast_start_ok = /** @type {(inputs: Cdo_Toast_Start_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã bắt đầu giao`)
};

/**

* @param {Cdo_Toast_Start_OkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_toast_start_ok = /** @type {((inputs?: Cdo_Toast_Start_OkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Toast_Start_OkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_toast_start_ok(inputs)
});